export default __webpack_public_path__ + "static/media/package_2.7f9ef2b0.png";